import React from 'react';

const Pagination = ({ page, listSearch, setPage, size }) => {
  return (
    <nav aria-label='Page navigation bg-transparent text-main'>
      <ul className='pagination txt-primary'>
        {page > 1 && (
          <li className='page-item' onClick={() => setPage(page - 1)}>
            <div
              className='page-link text-main bg-transparent'
              aria-label='Previous'
            >
              <span aria-hidden='true'>&laquo;</span>
            </div>
          </li>
        )}
        {listSearch.map((num, id) => {
          let ind = id + 1;

          if (ind <= Math.ceil(listSearch.length / size))
            return (
              <li className='page-item' onClick={() => setPage(ind)} key={id}>
                <div
                  className={`page-link  text-main ${
                    ind === page ? 'page-selected' : 'bg-transparent'
                  }`}
                >
                  {ind}
                </div>
              </li>
            );
        })}
        {page < listSearch.length / size && (
          <li className='page-item' onClick={() => setPage(page + 1)}>
            <div
              className='page-link bg-transparent text-main'
              aria-label='Next'
            >
              <span aria-hidden='true'>&raquo;</span>
            </div>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
